import {ENTITY_SERVICE_REGISTRY, EntityServiceEntry} from "../../core/shared/dto/dto-service/entity-service-registry";

export const HM_ENTITY_PROVIDER = [
    {
        provide: ENTITY_SERVICE_REGISTRY,
        useValue: [
            ['hm.IntegrationAzureGraphApi', {route: '/hm/integrationAzureGraphApis'}],
            ['hm.IntegrationAzureContainerConnection', {route: '/hm/integrationAzureContainerConnections'}],
        ] as EntityServiceEntry[],
        multi: true
    }
];
